import React from "react";
import { Row, Col } from "react-flexbox-grid";
import "./education.scss";
// Components
import TeamBox from './teamBox';
import TeamInfo from "./teamInfo";
import Title from "../ui-components/title/title";


const education = () => (
  <div id="education">
    <div className="wrapper">
      <Title title="EDUCATION" />
      <Row>
        <Col md={12} lg={4}>
        <TeamInfo degree="Bachelor of Science in Computer Science and Engineering (BSCSE)" 
        institution="North South University" years="2019-2023"  grade="CGPA : 3.79 (On a
        100% merit-based scholarship)" description="Relevant courses: Programming Language-I (C), Object Oriented Programming (Java), 
        Data Structures and Algorithms (C++), Discrete Mathematics, Junior Design, Introduction to Linear Algebra, Calculus and Analytic Geometry"/>
        </Col>
        
        <Col md={12} lg={4}>
          
          <TeamInfo degree="GCE Advanced Level" 
        institution="Scholastica" years="2018-2019" grade="ABBB" 
         description="Subjects: Computer Science, Physics, Chemistry, Mathematics (Pure Maths 1 and 3, Statistics 1 and Mechanics 1"/>
        </Col>
        <Col md={12} lg={4}>
        <TeamInfo degree="GCSE Ordinary Levels" 
        institution="Scholastica" years="2017" grade="2A* 4As" 
        description="Subjects: English, Physics, Chemistry, Accounting, General Mathematis, Additional Mathematics"/>
        </Col>
      </Row>
      
    </div>
  </div>
);

export default education;
